import React, { useMemo, useState, useRef } from "react"
import Leaflet from "leaflet"
import {
  MapContainer,
  TileLayer,
  useMap,
  Marker,
  useMapEvents,
} from "react-leaflet"
import "leaflet/dist/leaflet.css"
import icon from "leaflet/dist/images/marker-icon.png"
import iconShadow from "leaflet/dist/images/marker-shadow.png"
import iconRetina from "leaflet/dist/images/marker-icon-2x.png"
import "./style.scss"
import { Card, Col, Input, Row, Space, Typography } from "antd"
import { EditOutlined, CompassOutlined } from "@ant-design/icons"

const { Text } = Typography
const { TextArea } = Input

function MapComp({ coords, setDataAddress, mainAddress, matches_sm }) {
  let DefaultIcon = Leaflet.icon({
    ...Leaflet.Icon.Default.prototype.options,
    iconUrl: icon,
    iconRetinaUrl: iconRetina,
    shadowUrl: iconShadow,
  })
  Leaflet.Marker.prototype.options.icon = DefaultIcon

  function SetViewOnClick({ coords }) {
    const map = useMap()
    map.setView([coords.fullAddress.lat, coords.fullAddress.lng], map.getZoom())

    return null
  }
  function DraggableMarker({ coords }) {
    const [position, setPosition] = useState(
      coords.fullAddress.lat,
      coords.fullAddress.lng
    )
    const markerRef = useRef(null)
    const eventHandlers = useMemo(
      () => ({
        click(event) {
          setPosition(event.latlng)
        },
        dragend() {
          const marker = markerRef.current
          if (marker != null) {
            setPosition(marker.getLatLng())
          }
        },
      }),
      []
    )

    return (
      <Marker
        draggable={true}
        eventHandlers={eventHandlers}
        position={[coords.fullAddress.long, coords.fullAddress.lat]}
        ref={markerRef}
      ></Marker>
    )
  }
  function LocationMarker() {
    const [position, setPosition] = useState({
      latitude: coords.fullAddress.lat,
      longitude: coords.fullAddress.lng,
    })

    const map = useMapEvents({
      click(e) {
  
        const { lat, lng } = e.latlng
        setPosition({
          latitude: lat,
          longitude: lng,
        })
        setDataAddress({
          sectionId: coords.sectionId,
          fullAddress: { ...coords.fullAddress, lat: lat, lng: lng },
        })

        map.locate()
      },
      locationfound(e) {
        console.log("locationfound", e)
        const { lat, lng } = e.latlng
        setPosition({
          latitude: lat,
          longitude: lng,
        })

        map.flyTo(e.latlng, 11)
      },
    })

    return position.latitude !== 0 ? (
      <Marker
        position={[position.latitude, position.longitude]}
        interactive={false}
      />
    ) : null
  }
  function onChangeAddress (evt) {
    setDataAddress({
      sectionId: coords.sectionId,
      fullAddress: { ...coords.fullAddress, mainAddress: secondAddress + evt.target.value },
    })
  }
  const secondAddress =
    coords.fullAddress.pro +
    "-" +
    coords.fullAddress.cit +
    "-" +
    coords.fullAddress.sec +
    ":"

  return (
    <Row gutter={[matches_sm ? 0 : 12, matches_sm ? 10 : 12]}>
      <Col xs={24} md={12} order={matches_sm ? 2 : 1}>
        <Space direction="vertical" size={matches_sm ? 6 : 8} style={{ width: "100%" }}>
          <Space size={6}>
            <EditOutlined style={{ color: "#fa8c16", fontSize: matches_sm ? 13 : 14 }} />
            <Text type="secondary" style={{ fontSize: matches_sm ? 12 : 13 }}>
              آدرس دقیق
            </Text>
          </Space>
          <Card
            size="small"
            bordered={false}
            style={{
              borderRadius: matches_sm ? 10 : 12,
              background: "rgba(250,140,22,0.04)",
              border: "1px solid rgba(250,140,22,0.15)",
            }}
            bodyStyle={{ padding: matches_sm ? "8px 10px" : "10px 12px" }}
          >
            <Text type="secondary" style={{ fontSize: matches_sm ? 11 : 12, display: "block", marginBottom: 6 }}>
              {secondAddress}
            </Text>
            <TextArea
              name="fullAddress"
              rows={matches_sm ? 3 : 4}
              placeholder="آدرس را کامل وارد کنید"
              required
              defaultValue={mainAddress}
              onChange={onChangeAddress}
              style={{
                borderRadius: matches_sm ? 8 : 10,
                fontSize: matches_sm ? 13 : 14,
                resize: "none",
              }}
            />
          </Card>
        </Space>
      </Col>

      <Col xs={24} md={12} order={matches_sm ? 1 : 2}>
        <Space direction="vertical" size={matches_sm ? 6 : 8} style={{ width: "100%" }}>
          <Space size={6}>
            <CompassOutlined style={{ color: "#1677ff", fontSize: matches_sm ? 13 : 14 }} />
            <Text type="secondary" style={{ fontSize: matches_sm ? 12 : 13 }}>
              انتخاب روی نقشه
            </Text>
          </Space>
          <Card
            size="small"
            bordered={false}
            style={{
              borderRadius: matches_sm ? 10 : 12,
              overflow: "hidden",
              border: "1px solid rgba(22,119,255,0.15)",
              padding: 0,
            }}
            bodyStyle={{ padding: 0 }}
          >
            <MapContainer
              onClick={e => console.log("eeee", e)}
              style={{
                width: "100%",
                height: matches_sm ? 220 : 280,
                borderRadius: matches_sm ? 10 : 12,
              }}
              center={[coords.fullAddress.lat, coords.fullAddress.lng]}
              zoom={11}
              scrollWheelZoom={true}
              clickable={true}
            >
              <TileLayer
                attribution='<a href="http://vahedgas.ir">GasUnit</a>'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <LocationMarker />
              {/* <DraggableMarker  coords={coords} /> */}
              <SetViewOnClick coords={coords} />
            </MapContainer>
          </Card>
        </Space>
      </Col>
    </Row>
  )
}

export default MapComp
